import React from "react";
import { Box, Typography, Stack, Avatar, Card, CardContent, Fade, LinearProgress } from "@mui/material";
import SecurityIcon from '@mui/icons-material/Security';
import { keyframes } from "@emotion/react";

const pulse = keyframes`
  0% { transform: scale(1) }
  55% { transform: scale(1.16) }
  100% { transform: scale(1) }
`;

export default function AuthSplash({ username = "Team Member" }) {
    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                minHeight: 320,
                minWidth: 320,
                bgcolor: "#f7fafd",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                left: 0,
                top: 0,
                zIndex: 1700
            }}
        >
            <Card
                sx={{
                    minWidth: 340,
                    maxWidth: 420,
                    boxShadow: 10,
                    borderRadius: 3,
                    px: 2,
                    bgcolor: "white",
                    position: "relative",
                    overflow: "visible"
                }}
            >
                {/* Busy Linear Progress bar */}
                <Box sx={{ position: "absolute", left: 0, top: 0, width: "100%" }}>
                    <LinearProgress
                        color="primary"
                        sx={{
                            height: 5,
                            bgcolor: "#e7ebf0",
                            "& .MuiLinearProgress-bar": {
                                backgroundColor: "#005AA6"
                            }
                        }}
                    />
                </Box>
                <CardContent>
                    <Stack spacing={4} alignItems="center" py={2}>
                        <Fade in timeout={800}>
                            <Avatar
                                sx={{
                                    bgcolor: "#005AA6",
                                    width: 88,
                                    height: 88,
                                    boxShadow: 4,
                                    animation: `${pulse} 1.1s infinite`,
                                }}
                            >
                                <SecurityIcon sx={{ fontSize: 50, color: "#fff" }} />
                            </Avatar>
                        </Fade>
                        <Fade in timeout={1000}>
                            <Typography
                                sx={{
                                    color: "#000E54",
                                    fontFamily: "Montserrat, Roboto, Arial",
                                    fontWeight: 700,
                                    fontSize: "1.45rem",
                                    letterSpacing: 1,
                                    textAlign: "center"
                                }}
                            >
                                Welcome to NOC Dashboard
                            </Typography>
                        </Fade>
                        <Fade in timeout={1600}>
                            <Typography
                                sx={{
                                    color: "#1e3a8a",
                                    fontFamily: "Montserrat, Roboto, Arial",
                                    fontWeight: 500,
                                    fontSize: "1.01rem",
                                    textAlign: "center",
                                    maxWidth: "320px"
                                }}
                            >
                                Securely verifying your identity and preparing your dashboard...
                            </Typography>
                        </Fade>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}
